import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ViewportService } from 'src/app/services/viewport.service';
import { slideUpFast } from 'src/app/utilities/animations';
import {
    generateGoogleFlightsUrl,
    GoogleFlightUrlParams,
} from 'src/app/utilities/googleFlightsUrlGenerator';
import { DateTime } from 'luxon';
import { generateSkyscannerUrl } from 'src/app/utilities/skyscannerUrlGenerator';
import { FlightClass } from 'src/app/models/DealsModels';
import { AuthService } from 'src/app/services/auth.service';
import { UserModel } from 'src/app/models/User';
import { take } from 'rxjs/operators';
import { PriceTrackingModalComponent } from '../price-tracking-modal/price-tracking-modal.component';
import { openModal } from 'src/app/utilities/helpers';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
    selector: 'book-flight-modal',
    templateUrl: './book-flight-modal.component.html',
    styleUrl: './book-flight-modal.component.css',
    animations: [slideUpFast],
    host: { '[@slideUpFast]': '' },
    providers: [DialogService],
})
export class BookFlightModalComponent implements OnInit, OnDestroy {
    @Input() visible = false;
    @Output() onClose = new EventEmitter<void>();

    PriceTrackingModalComponent = PriceTrackingModalComponent;
    openModal = openModal;
    user: UserModel | null = null;

    startDate = '';
    endDate = '';
    destinationIata = '';
    departureIata = '';
    itineraryDates = '';
    flightClass: FlightClass;

    googleUrl = '';
    skyScannerUrl = '';

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public viewport: ViewportService,
        private auth: AuthService,
        public dialogService: DialogService,
        private mixpanel: MixpanelService
    ) {}

    ngOnInit() {
        const data = this.config?.data || {};

        this.startDate = data.startDate;
        this.endDate = data.endDate;
        this.destinationIata = data.destinationIata;
        this.departureIata = data.departureIata;
        this.itineraryDates = data.itineraryDates;
        this.flightClass = data.flightClass;

        this.googleUrl = generateGoogleFlightsUrl({
            startDate: this.startDate,
            returnDate: this.endDate,
            departureAirportCode: this.departureIata,
            destinationAirportCode: this.destinationIata,
            flightClass: this.flightClass,
        } as GoogleFlightUrlParams);

        this.skyScannerUrl = generateSkyscannerUrl(
            this.departureIata,
            this.destinationIata,
            this.startDate,
            this.endDate,
            this.flightClass
        );

        this.auth.user$.pipe(take(1)).subscribe((u) => {
            this.user = u;
            this.mixpanel.identify(u.id.toString());
        });
    }

    ngOnDestroy(): void {}

    hide() {
        this.onClose.emit();
    }

    close() {
        this.ref.close();
    }


    formatDate(iso: string): string {
        if (!iso) return '';
        const dt = DateTime.fromISO(iso, { zone: 'local' });
        return dt.toLocaleString({
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        });
      }

    private openBookingUrl(url: string, source: string) {
        this.mixpanel.track(`View on ${source} link clicked`, {
            email: this.user.email,
            deal_name: (`${this.departureIata} to ${this.destinationIata}`),
            trip_from: this.departureIata,
            trip_to: this.destinationIata
        });
        if (url) window.open(url, '_blank');
    }

    openGoogle() {
        this.openBookingUrl(this.googleUrl, 'Google');
    }

    openSkyScanner() {
        this.openBookingUrl(this.skyScannerUrl, 'Skyscanner');
    }
}
